// Imports
import { Octokit } from '@octokit/core'

export default new Octokit()
